import '../../polyfills/array.find.js'; // For IE 11

import tippy from 'tippy.js';

export default function init() {
	const tooltipElems = document.querySelectorAll('.annotation__target');

	for (var idx = 0; idx < tooltipElems.length; idx++) {
		var elm = tooltipElems[idx];

		tippy(elm, {
			content: elm.nextElementSibling.innerHTML,
			allowHTML: true,
			interactive: true,
			animation: 'shift-toward-subtle',
			placement: 'bottom', // preferred placement
		});
	
	}
}